module.exports = __webpack_public_path__ + "img/1-gray-cartoon.ecc41886.png";